package one.healthium.domain.user.models

import kotlinx.serialization.Serializable
import kotlin.time.Instant

@Serializable
data class SymptomsLogModel(
    val id: String,
    val date: Instant,
    val symptoms: List<SymptomModel>,
)
